
import { defineComponent, reactive, ref, toRefs } from "vue";
import axios from "axios";

export default defineComponent({
  setup() {
    const data = reactive({
      icon: "success",
      text: "恭喜，抖音账号绑定成功！",
      i: 2,
      state: "",
      ifshow: true,
    });
    const stateMap = new Map<number, number>();
    stateMap.set(203, 6);
    stateMap.set(3, 2);
    stateMap.set(4, 5);
    stateMap.set(10, 3);
    stateMap.set(6, 4);
    const state = (i: number) => {
      return stateMap.get(i) || 1;
    };
    const info = ref();
    const sdk = (window as any).DouyinOpenJSBridge;
    const params = new URL(location.href).searchParams;
    const signature = () => {
      axios
        .get("/api/callback/signature", {
          params: {
            state: data.state,
          },
        })
        .then((res) => {
          info.value = res.data.response;
          info.value.avatar = "https://xyjx.novajo.cn" + info.value.avatar;
          sdk.config({
            params: info.value.sign,
          });
        });
    };

    const redirect = () => {
      window.location.href = "/api/callback/redirect?state=" + data.state;
    };

    const handleResult = (i: number, response?: any) => {
      data.i = i;
      if (i == 0) {
        data.text = "恭喜，抖音账号绑定成功！";
        data.icon = "success";
      } else if (i == 5) {
        data.text = "该抖音账号已被绑定！";
        data.icon = "error";
        const dy = params.get("dy") || (response && response.dy);
        const wx = params.get("wx") || (response && response.wx) || "其他人";
        if (dy) {
          data.text = "该账号[" + dy + "]已被绑定到[" + wx + "]名下";
        }
      } else if (i == 2 || i == 3) {
        data.text = "状态获取失败，请重授权~";
        data.icon = "warn";
      } else if (i == 4 || i == 1) {
        data.text = "出错了~";
        data.icon = "error";
      } else if (i == 6) {
        data.text = "该账号不具备橱窗管理，带货权限，绑定失败";
        data.icon = "error";
      }
    };

    const isDouyin = () => {
      const APP_VERSION_REGX = {
        android: new RegExp("app_version/", "i"),
        ios: new RegExp("aweme_", "i"),
      };
      const ua = navigator.userAgent;
      const os = /(Android);?\s+([\d.]+)?/i.test(ua) ? "android" : "ios";
      const version = parseFloat(ua.split(APP_VERSION_REGX[os])[1]);
      return !!version;
    };

    const updatestate = () => {
      data.state = params.get("state") || "";
      if (sdk && isDouyin()) {
        signature();
      } else if (!params.get("result") && data.state) {
        redirect();
      } else if (params.get("result") || !data.state) {
        let result = params.get("result");
        if (!result && !data.state) {
          result = "1";
        }
        data.ifshow = false;
        handleResult(Number(result));
      }
    };

    updatestate();

    const dyck = () => {
      const scopes: any = {};
      const arr = info.value.scope.split(",");
      arr.forEach((r: string) => {
        if (r) {
          scopes[r] = 0;
        }
      });
      sdk.showOpenAuth({
        params: {
          client_key: info.value.sign.client_key,
          state: info.value.state,
          scopes: scopes,
          response_type: "code",
        },
        success: ({ response }: any) => {
          if (response.grant_permissions.length > 9) {
            axios
              .get("/api/callback/grant", {
                params: {
                  code: response.ticket,
                  state: data.state,
                },
              })
              .then((res) => {
                data.ifshow = false;
                const i = res.data.status;
                handleResult(i == 0 ? 0 : state(i), res.data.response);
              });
          }
        },
      });
    };
    return {
      ...toRefs(data),
      info,
      dyck,
    };
  },
});
